import React from 'react';
import { Link } from "react-router-dom";
import { MODALS } from '../../../../config/images';
const ModalSurveysCount = ({showModalSurveysCount, closeModal, countNotResponded, userName}) => {
    if (!showModalSurveysCount) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[33.33%] sm:w-[60%] w-[88%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4  ">
                <div className='flex justify-end'>
                <button
                    onClick={closeModal}
                    className="px-4 py-2 rounded-md"
                >
                    <img src={MODALS.CLOSE} alt="cerrar"/>
                </button>
                </div>
                <div className='flex items-start justify-between gap-3 p-4 md:px-10 md:flex-row'>
                    <img src={MODALS.WARNING} alt="warning"/>
                    <div className='flex flex-col w-full'>
                    <p className="text-xs md:text-sm font-itcdemi">
                        {`Estimado ${userName}, tiene ${countNotResponded} encuestas pendientes por responder.`}
                    </p>
                    <p className='md:text-xs text-[10px] font-itcbook break-words'>
                        <Link
                            to="/mis-encuestas"
                            className="text-blue-600 underline cursor-pointer hover:text-blue-800"
                        >
                            Responda sus encuestas
                        </Link>
                    </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ModalSurveysCount;